import request from '@/utils/request'
import {
  GetPhotoStatusResult,
  GetCredentialsListDataItem,
  createPhotoApplyParam,
  credentialsDetailParams,
  credentialsDetailResult,
  getCredentialsApplyLogResult,
} from '@/types/my-credentials'

// 证件头像信息
export function GetPhotoStatus(): Promise<GetPhotoStatusResult> {
  return request.get('/api-train/applets/user/photo_apply_status')
}

// 用户证件
export function GetCredentialsList(): Promise<Array<GetCredentialsListDataItem>> {
  return request.get('/api-train/applets/user/events')
}

// 创建头像
export function createPhotoApply(params: createPhotoApplyParam): Promise<void> {
  return request.post('/api-train/applets/user/create_photo_apply', params)
}

// 证件详情
export function credentialsDetail(
  params: credentialsDetailParams
): Promise<credentialsDetailResult> {
  return request.get('/api-train/applets/user/event', { params })
}

// 申请记录
export function getCredentialsApplyLog(): Promise<getCredentialsApplyLogResult> {
  return request.get('/api-train/inner_oauth_token/certificate/certificate_apply/get_account_list')
}

// 下载电子证
export function downLoadCredential(param: { type: string }): Promise<{ file_url: string }> {
  return request.post('/api-train/applets/user/download_electronic_certificate', param)
}
